import React, { FC, memo, useState, useEffect } from "../../../lib/teact/teact";
import { formatDateToString } from "../../../util/dateFormat";
import Button from "../../ui/Button";
import ConfirmDialog from "../../ui/ConfirmDialog";
import DropdownMenu from "../../ui/DropdownMenu";
import InputText from "../../ui/InputText";
import MenuItem from "../../ui/MenuItem";
import { AdminApi } from "../restapi/adminApi";
import LotInputtext from "../ui/lotInputtext";
import LotSelect from "../ui/lotSelect";
import Snackbar from "../ui/snackbar";
import { getDateStringVN } from "../utils/DateTimeUtils";
import { isCuPhapMb } from "../utils/common";
import { AdminScreens } from "./AdminScreen";

type OwnProps = {
    editType: "add" | "edit";
    curUser?: any;
    onChangeScreen?: (screen: any) => void;
}
const CreateAgent: FC<OwnProps> = ({
    editType,
    curUser,
    onChangeScreen
}) => {
    const [state, setState] = useState({
        mienCuPhapId: 2,
        dmTinh: [],
        tinhId: "TP",
        username: "",
        password: "",
        thongBao: "Điền đầy đủ thông tin để tạo/sửa tài khoản",
        user: curUser,  // chỉ dùng khi edit mới có
        ghiChu: "",
        soThangThem: 0,
        soThangHuy: 0,
        snackbarOpen: false,
        snackbarMessage: "",
        showThanhToan: false,
        soThangThanhToan: 0,
        dbName: 'lotterynew',
        loginLimit: 1,
        lienHe: '',
        parserVersion: 'v1',
    })
    useEffect(() => {

        AdminApi.FetchDmTinh().then(result => {
            let newState = { ...state, dmTinh: result.data }
            if (curUser) {
                newState = {
                    ...state, dmTinh: result.data,
                    user: curUser,
                    username: curUser.data.username,
                    tinhId: curUser.data.tinhId, mienCuPhapId: curUser.data.mienCuPhapId,
                    ghiChu: curUser.data.ghiChu,
                    dbName: curUser.data.dbName,
                    loginLimit: curUser.data.loginLimit ? curUser.data.loginLimit : 1,
                    lienHe: curUser.data.lienHe,
                    parserVersion: curUser.data.parserPort=="8080"?"v1":"v2",
                }
            }
            setState(prev => ({ ...prev, ...newState }))

        })
    }, [])
    useEffect(() => {
        // if (curUser) {
        //     setState(prev => ({
        //         ...prev, user: curUser, username: curUser.username,
        //         tinhId: curUser.tinhId, mienCuPhapId: curUser.mienCuPhapId
        //     }))
        // }

    }, [curUser])
    function handleCreateUser() {
        const payload = {
            username: state.username,
            password: state.password,
            mienCuphapId: state.mienCuPhapId,
            tinhId: state.tinhId,
        }
        AdminApi.PostCreateUser(payload).then((result) => {

            setState(prev => ({ ...prev, thongBao: result.responseText }))

        })
    }
    function handleUpdateUser() {
        const payload = {
            username: state.username,
            password: state.password,
            mienCuphapId: state.mienCuPhapId,
            tinhId: state.tinhId,
            soThangCap: state.soThangThem,
            soThangHuy: state.soThangHuy,
            ghiChu: state.ghiChu,
            dbName: state.dbName,
            loginLimit: state.loginLimit,
            lienHe: state.lienHe,
            parserVersion: state.parserVersion,
        }
        AdminApi.PostUpdateUser(payload).then((result) => {
            let tmp = state.user;
            tmp.data = result.data
            setState(prev => ({
                ...prev, thongBao: result.responseText,
                snackbarOpen: true,
                snackbarMessage: result.responseText,
                user: tmp
            }))

        })
    }
    return (
        <div className=" form-main">

            <div className="form-content">
                <div>
                    {state.thongBao}
                </div>
                <div className=" common-container-row">
                    <div className={editType == "edit" ? "common-container-row left-panel" : "common-container-row full-width"}>
                        <InputText label="Tên tài khoản" value={state.username}
                            onChange={(e) => { setState(prev => ({ ...prev, username: e.target.value })) }}
                            disabled={editType == "edit"}
                        ></InputText>
                    </div>
                    {editType == "edit" && <div>
                        <DropdownMenu positionX="right" positionY="top">
                            <MenuItem onClick={() => {
                                setState(prev => ({ ...prev, showThanhToan: true }))
                            }}>Thanh toán</MenuItem>
                        </DropdownMenu>
                    </div>}
                </div>
                <LotInputtext label="Mật khẩu" type="password" value={state.password}
                    onChange={(e) => { setState(prev => ({ ...prev, password: e.target.value })) }}
                ></LotInputtext>

                <div className=" common-container-row">
                    <div>Cú pháp tin nhắn</div>
                    <LotSelect value={state.mienCuPhapId + ""}
                        onChange={(e) => {
                            let tinhId = 'TP';
                            const mienCuPhapId = Number(e.target.value);
                            if (mienCuPhapId == 1)
                                tinhId = 'HN'
                            setState(prev => ({ ...prev, tinhId: tinhId, mienCuPhapId: mienCuPhapId }))
                        }} id="lotSelect">
                        <option value="1" selected={state.mienCuPhapId == 1}>Miền Bắc</option>
                        <option value="2" selected={state.mienCuPhapId == 2}>Miền Nam</option>
                    </LotSelect>
                </div>
                <div className=" common-container-row">
                    <div>Từ điển cú pháp vùng</div>
                    <LotSelect value={state.tinhId} onChange={(e) => {
                        setState(prev => ({ ...prev, tinhId: e.target.value }))

                    }} id="lotSelect-tinh">
                        {
                            state.dmTinh.filter((item: any) => {
                                return item.mienCuPhapId == state.mienCuPhapId
                            }).map((item: any) => {
                                return (<option
                                    selected={state.tinhId == item.tinhId}
                                    value={item.tinhId}>{item.tenTinh}</option>)
                            })
                        }
                    </LotSelect>
                </div>
                <div className=" common-container-row">
                    <div>Phân vùng dữ liệu</div>
                    <LotSelect value={state.dbName + ""}
                        onChange={(e) => {

                            const dbName = (e.target.value);

                            setState(prev => ({ ...prev, dbName: dbName }))
                        }} id="lotSelect">
                        <option value="lotterynew" selected={state.dbName == 'lotterynew'}>lotterynew</option>
                        <option value="lotterynew1" selected={state.dbName == 'lotterynew1'}>lotterynew1</option>
                    </LotSelect>

                </div>
                <div className=" common-container-row">
                    <div>Chop phép đăng nhập đồng thời</div>
                    <LotSelect value={state.loginLimit + ""}
                        onChange={(e) => {

                            const limit = Number(e.target.value);

                            setState(prev => ({ ...prev, loginLimit: limit }))
                        }} id="loginLimit">
                        <option value="1" selected={state.loginLimit == 1}>1</option>
                        <option value="2" selected={state.loginLimit == 2}>2</option>
                        <option value="3" selected={state.loginLimit == 3}>3</option>
                        <option value="4" selected={state.loginLimit == 4}>4</option>
                        <option value="5" selected={state.loginLimit == 5}>5</option>
                        <option value="6" selected={state.loginLimit == 6}>6</option>
                        <option value="7" selected={state.loginLimit == 7}>7</option>
                        <option value="8" selected={state.loginLimit == 8}>8</option>
                        <option value="9" selected={state.loginLimit == 9}>9</option>
                        <option value="10" selected={state.loginLimit == 10}>10</option>
                    </LotSelect>
                </div>
                {/* <div className=" common-container-row">
                    <div>Mẫu báo cáo</div>
                    <LotSelect value="1" onChange={() => { }} id="lotSelect-maubc">
                        <option value="1">Phổ biến</option>
                        <option value="2">Gộp 2c,3c,da theo sài gòn</option>
                    </LotSelect>
                </div> */}
                <InputText inputMode="text" label="Liên hệ"
                    value={state.lienHe}
                    onChange={(e) => { setState(prev => ({ ...prev, lienHe: e.target.value })) }}
                ></InputText>
                <InputText inputMode="text" label="Ghi chú"
                    value={state.ghiChu}
                    onChange={(e) => { setState(prev => ({ ...prev, ghiChu: e.target.value })) }}
                ></InputText>
                {state.user &&
                    <div>
                        <InputText value={getDateStringVN(state.user.data.expDate)} disabled={true} label="Sử dụng đến"></InputText>

                        <div className=" common-container-row">
                            <InputText inputMode="numeric" label="Số tháng cấp thêm"
                                value={state.soThangThem}
                                onChange={(e) => {
                                    const soThang = Number(e.target.value)
                                    setState(prev => ({ ...prev, soThangThem: soThang, soThangHuy: 0 }))
                                }
                                }
                            ></InputText>
                            <InputText inputMode="numeric" label="Số tháng huỷ"
                                value={state.soThangHuy}
                                onChange={(e) => {
                                    const soThang = Number(e.target.value)
                                    setState(prev => ({ ...prev, soThangHuy: soThang, soThangThem: 0 }))
                                }
                                }
                            ></InputText>
                        </div>
                        <div className=" common-container-row">
                            <div>Sử dụng bộ phân tích</div>
                            <LotSelect value={state.parserVersion  }
                                onChange={(e) => {

                                    const parserVersion = (e.target.value);

                                    setState(prev => ({ ...prev, parserVersion: parserVersion }))
                                }} id="parserVersion">
                                <option value="v1" selected={state.parserVersion == 'v1'}>v1</option>
                                <option value="v2" selected={state.parserVersion == 'v2'}>v2</option>
                            </LotSelect>

                        </div>
                    </div>
                }

                {editType == "add" &&
                    <div>
                        <Button onClick={handleCreateUser}>Tạo tài khoản</Button>
                    </div>
                }
                {editType == "edit" &&
                    <div>
                        <Button onClick={handleUpdateUser}>Lưu lại</Button>
                    </div>
                }
            </div>
            <Snackbar isOpen={state.snackbarOpen} message={state.snackbarMessage}
                triggerTime={JSON.stringify(new Date())}
                onClose={() => { setState(prev => ({ ...prev, snackbarOpen: false })) }}
            />
            <ConfirmDialog isOpen={state.showThanhToan}
                onClose={() => { setState(prev => ({ ...prev, showThanhToan: false })) }}
                confirmHandler={() => {
                    const payload = { userId: curUser.data.userId, soThang: state.soThangThanhToan }
                    AdminApi.PostThanhToan(payload).then(result => {
                        if (result.errorCode == 0) {
                            setState(prev => ({ ...prev, showThanhToan: false, snackbarOpen: true, snackbarMessage: result.responseText }))
                        } else {
                            setState(prev => ({ ...prev, snackbarOpen: true, snackbarMessage: result.responseText }))
                        }
                    })
                }}
                confirmLabel="Xác nhận"
                title="Xác nhận thanh toán"
                text="Thanh toán với cấp dưới"
            >
                <LotInputtext label="Số tháng"
                    value={state.soThangThanhToan}
                    onChange={(e) => {
                        setState(prev => ({ ...prev, soThangThanhToan: Number(e.target.value) }))
                    }
                    }
                ></LotInputtext>
            </ConfirmDialog>
        </div >
    )
}

export default memo(CreateAgent)